export interface EmployeeMetadata {
  totalDocuments: number;
  totalBulletins: number;
}

export interface EmployeeSummary {
  uuid: string;
  remoteId?: number | null;
  folderUuid?: string | null;
  matriculeSalarie?: string | null;
  civilite?: number | null;
  nomUsage?: string | null;
  nomNaissance?: string | null;
  nom?: string | null;
  prenom?: string | null;
  email?: string | null;
  telephone?: string | null;
  dateNaissance?: string | null;
  isActive?: boolean | null;
  contratActif?: boolean | null;
  metadata?: EmployeeMetadata | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export type Employee = EmployeeSummary;

export interface EmployeeAddress {
  ligne1?: string | null;
  ligne2?: string | null;
  codePostal?: string | null;
  ville?: string | null;
  pays?: string | null;
  inseeCode?: string | null;
  codeDistributionEtranger?: string | null;
  fiscalResidentAbroad?: boolean | null;
  borderWorker?: boolean | null;
}

export interface EmployeeBank {
  iban?: string | null;
  bic?: string | null;
  virement?: boolean | null;
}

export interface EmployeeContract {
  uuid: string;
  remoteId: number;
  numeroContrat?: string | null;
  codeEtablissement?: string | null;
  establishmentUuid?: string | null;
  establishmentNom?: string | null;
  dateDebut?: string | null;
  dateFinPrevisionnelle?: string | null;
  dateFinEffective?: string | null;
  isActif: boolean;
  estCourant: boolean;
}

export interface EmployeeDetails extends EmployeeSummary {
  folderUuid: string;
  nationalite?: string | null;
  communeNaissance?: string | null;
  departementNaissance?: string | null;
  paysNaissance?: string | null;
  numeroSecuriteSociale?: string | null;
  adresse?: EmployeeAddress | null;
  banque?: EmployeeBank | null;
  contrats: EmployeeContract[];
  metadata?: EmployeeMetadata | null;
}

export interface ContractSchedule {
  monthlyHours?: number | null;
  weeklyHours?: number | null;
  dailyHours?: {
    monday?: number | null;
    tuesday?: number | null;
    wednesday?: number | null;
    thursday?: number | null;
    friday?: number | null;
    saturday?: number | null;
    sunday?: number | null;
  } | null;
}

export interface ContractTermination {
  exitDate?: string | null;
  motive?: string | null;
  lastWorkedDay?: string | null;
  notificationDate?: string | null;
}

export interface EmploymentContractDetails extends EmployeeContract {
  employee?: EmployeeSummary | null;
  employeeAdresse?: EmployeeAddress | null;
  employeeBanque?: EmployeeBank | null;
  employmentType?: number | null;
  partTimeType?: number | null;
  professionalStatus?: number | null;
  retirementScheme?: number | null;
  monthlySalary?: number | null;
  hourlySalary?: number | null;
  salarieTempsPartiel?: boolean | null;
  forfaitJour?: boolean | null;
  schedule?: ContractSchedule | null;
  termination?: ContractTermination | null;
  metadata?: Record<string, unknown> | null;
}

export interface EmployeesQueryParams {
  page?: number;
  limit?: number;
  keyword?: string;
  establishmentUuid?: string;
  search?: string;
  status?: 'all' | 'active' | 'inactive';
  contractStatus?: 'all' | 'active' | 'terminated';
}

export interface EmployeesListResponse {
  data: Employee[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface EmployeeDetailResponse {
  data: EmployeeDetails;
  meta?: {
    timestamp: string;
    path: string;
    statusCode: number;
  };
}

export const CIVILITE_MAP: Record<number, string> = {
  1: 'M.',
  2: 'Mme',
  3: 'Mlle',
};
